
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const PlanDistribution: React.FC = () => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">
          Distribuição de Planos
        </CardTitle>
        <CardDescription>Usuários por tipo de plano</CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 rounded-full bg-gray-400"></div>
                <span className="text-sm">Gratuito</span>
              </div>
              <span className="font-medium">211</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 rounded-full bg-green-500"></div>
                <span className="text-sm">Básico</span>
              </div>
              <span className="font-medium">87</span>
            </div>
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 rounded-full bg-blue-500"></div>
                <span className="text-sm">Premium</span>
              </div>
              <span className="font-medium">98</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1">
                <div className="w-3 h-3 rounded-full bg-purple-500"></div>
                <span className="text-sm">VIP</span>
              </div>
              <span className="font-medium">31</span>
            </div>
          </div>
        </div>
        
        <div className="h-1 w-full bg-gray-100 mt-4 rounded-full overflow-hidden">
          <div className="flex h-full">
            <div className="h-full bg-gray-400" style={{ width: "49.4%" }}></div>
            <div className="h-full bg-green-500" style={{ width: "20.4%" }}></div>
            <div className="h-full bg-blue-500" style={{ width: "22.9%" }}></div>
            <div className="h-full bg-purple-500" style={{ width: "7.3%" }}></div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlanDistribution;
